import { createContext, useContext } from "react";
import { UseCheckoutFormReturn } from "./hooks/useCheckoutForm";

export const CheckoutFormContext = createContext<UseCheckoutFormReturn | null>(
    null,
);

export const useCheckoutFormContext = (): UseCheckoutFormReturn => {
    const context = useContext(CheckoutFormContext);
    if (!context) {
        throw new Error(
            "useCheckoutFormContext must be used within CheckoutPageContainer",
        );
    }
    return context;
};
